export const PRODUCT_DETAILS_QUERY_PARAMS = {
  INFO_LAYER: 'info',
};
